<template>
  <div class="home">
    <!-- pc端 -->
    <div v-if="isMaxScreen" class="main-content">
      <div class="final-price-box">
        <h5 v-if="![18].includes(Number(orderInfo?.goodsStatus))">
          {{ $t('component.tradeInProcess.finPirce') }}
        </h5>
        <!-- 最终价格 -->
        <template v-if="[7, 15, 17].includes(Number(orderInfo?.goodsStatus))">
          <p class="congratulation-text">{{ $t('component.tradeInProcess.congratulation') }}</p>

          <div class="price-box congra-box">
            <div class="price-item">
              <span class="price-item-text">{{ $t('component.tradeInProcess.total') }}</span>
              <div class="coin-amount">
                <span class="coin">{{ orderInfo.currency }}</span>
                <span class="amount">{{ orderInfo.trancePrice }}</span>
              </div>
            </div>
          </div>
        </template>
        <!-- 回收失败 总价 -->
        <template v-else-if="Number(orderInfo?.goodsStatus) == 18">
          <p class="reclaim-failure-text">{{ $t('component.tradeInProcess.userRes') }}</p>
          <div class="reclaim-failure-price-box">
            <div class="price-item">
              <span class="price-item-text">{{ $t('component.tradeInProcess.total') }}</span>
              <div class="coin-amount">
                <span class="coin">{{ orderInfo.currency }}</span>
                <span class="amount">{{ orderInfo.trancePrice }}</span>
              </div>
            </div>
          </div>
        </template>
        <!-- 补贴价。原价 -->
        <template v-else>
          <p class="congratulation-text2">{{ $t('component.tradeInProcess.successPrice') }}</p>
          <div class="price-box">
            <template v-if="shouldShowPriceBreakdown">
              <!-- 显示详细价格分解 -->
              <div class="price-item">
                <span class="price-item-text">{{ $t('component.tradeInProcess.price') }}</span>
                <div class="coin-amount">
                  <span class="coin">{{ orderInfo.currency }}</span>
                  <span class="amount">{{ orderInfo.qcPrice || 0 }}</span>
                </div>
              </div>

              <template v-if="orderInfo.bonusSwitch  && orderInfo.detectionBonus > 0">
                <div class="symbol">+</div>
                <div class="price-item">
                  <span class="price-item-text">{{ $t('component.tradeInProcess.bonus') }}</span>
                  <div class="coin-amount">
                    <span class="coin">{{ orderInfo.currency }}</span>
                    <span class="amount">{{ orderInfo.detectionBonus || 0 }}</span>
                  </div>
                </div>
              </template>

              <template v-if="orderInfo.expertDiscount && orderInfo.expertDiscount > 0">
                <div class="symbol">+</div>
                <div class="price-item">
                  <span class="price-item-text">{{
                    $t('component.tradeInProcess.expertDiscount')
                  }}</span>
                  <div class="coin-amount">
                    <span class="coin">{{ orderInfo.currency }}</span>
                    <span class="amount">{{ orderInfo.expertDiscount || 0 }}</span>
                  </div>
                </div>
              </template>

              <div class="symbol">=</div>
            </template>

            <!-- 总价部分 -->
            <div class="price-item">
              <span class="price-item-text">{{ $t('component.tradeInProcess.total') }}</span>
              <div class="coin-amount">
                <span class="coin">{{ orderInfo.currency }}</span>
                <span class="amount">{{ orderInfo.trancePrice || 0 }}</span>
              </div>
            </div>
          </div>
          <div class="btn-box">
            <el-button class="btn btn-sure" @click="handleClick(1)">{{
              $t('component.tradeInProcess.sure')
            }}</el-button>
            <el-button class="btn btn-reject" @click="handleClick(2)">{{
              $t('component.tradeInProcess.Reject')
            }}</el-button>
          </div>
        </template>
      </div>
    </div>
    <!-- 移动端 -->
    <div v-else class="main-content">
      <div class="final-price-box">
        <h5>
          {{$t('component.tradeInProcess.finPirce')}}
          <img
            v-if="![7, 15, 17, 18].includes(Number(orderInfo?.goodsStatus))"
            src="../../../assets/image/order/wenhao_icon.png"
            alt=""
            class="price-wenhao-icon"
            @click="handleClickWenhao"
          />
        </h5>
        <!-- 最终价格 -->
        <template v-if="[7, 15, 17].includes(Number(orderInfo?.goodsStatus))">
          <p class="congratulation-text">{{ $t('component.tradeInProcess.congratulation') }}</p>
          <div class="price-box congra-box">
            <div class="price-item">
              <span class="price-item-text">{{ $t('component.tradeInProcess.total') }}</span>
              <div class="coin-amount">
                <span class="coin">{{ orderInfo.currency }}</span>
                <span class="amount">{{ orderInfo.trancePrice }}</span>
              </div>
            </div>
          </div>
        </template>
        <!-- 回收失败 总价 -->
        <template v-else-if="Number(orderInfo?.goodsStatus) == 18">
          <p class="reclaim-failure-text">{{ $t('component.tradeInProcess.userRes') }}</p>
          <div class="reclaim-failure-price-box">
            <div class="price-item">
              <span class="price-item-text">{{ $t('component.tradeInProcess.total') }}</span>
              <div class="coin-amount">
                <span class="coin">{{ orderInfo.currency }}</span>
                <span class="amount">{{ orderInfo.trancePrice }}</span>
              </div>
            </div>
          </div>
        </template>
        <!-- 补贴价。原价 -->
        <template v-else>
          <div class="price-total">
            <!-- <span class="price-item-text">{{ $t('component.tradeInProcess.total') }}</span> -->
            <div class="coin-amount">
              <span class="coin">{{ orderInfo.currency }}</span>
              <span class="amount">{{ orderInfo.trancePrice }}</span>
            </div>
          </div>
          <!-- 只在有奖金或专家折扣时显示价格明细 -->
          <div v-if="shouldShowPriceBreakdown" class="price-box">
            <div class="price-item">
              <span class="price-item-text">{{ $t('component.tradeInProcess.price') }}</span>
              <div class="coin-amount">
                <span class="coin">{{ orderInfo.currency }}</span>
                <span class="amount">{{ orderInfo.qcPrice }}</span>
              </div>
            </div>
            <template v-if="orderInfo.bonusSwitch  && orderInfo.detectionBonus > 0">
              <div class="symbol">+</div>
              <div class="price-item">
                <span class="price-item-text">{{ $t('component.tradeInProcess.bonus') }}</span>
                <div class="coin-amount">
                  <span class="coin">{{ orderInfo.currency }}</span>
                  <span class="amount">{{ orderInfo.detectionBonus || 0 }}</span>
                </div>
              </div>
            </template>
            <template v-if="orderInfo.expertDiscount && orderInfo.expertDiscount > 0">
              <div class="symbol">+</div>
              <div class="price-item">
                <span class="price-item-text">{{
                  $t('component.tradeInProcess.expertDiscount')
                }}</span>
                <div class="coin-amount">
                  <span class="coin">{{ orderInfo.currency }}</span>
                  <span class="amount">{{ orderInfo.expertDiscount }}</span>
                </div>
              </div>
            </template>
          </div>
          <div class="btn-box">
            <van-button class="btn btn-sure" @click="handleClick(1)">{{
              $t('component.tradeInProcess.sure')
            }}</van-button>
            <van-button class="btn btn-reject" @click="handleClick(2)">{{
              $t('component.tradeInProcess.Reject')
            }}</van-button>
          </div>
        </template>
      </div>
      <!-- 价格不一致温馨提示弹窗 -->
      <van-dialog
        v-model="dialogVisible"
        :title="$t('shippingLable.shippingLable.649fhwpa2h80')"
        :show-confirm-button="false"
        close-on-click-overlay
      >
        <div class="dialog-content">
          <div class="row">
            {{ $t('component.tradeInProcess.successPrice') }}
          </div>
        </div>
        <div class="dialog-btn-box">
          <van-button class="dialog-btn" @click="handleClickWenhao">{{$t('component.tradeInProcess.understand')}}</van-button>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
// goodsStatus
// "2", descs:"待检测"
// "3", descs:"待解锁"
// "4", descs:"待议价"
// "7", descs:"已成交"
// "15", descs:"带锁已成交"
// "17", descs:"已售出"
// "18", descs:"已退单"
import { mapState } from 'vuex';

import { orderReject } from '../../../services/api/brandList.js';
export default {
  name: 'finalPrice',
  components: {},
  props: {
    orderInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    }),
    shouldShowPriceBreakdown() {
      // 当有奖金或专家折扣时才显示价格明细
      return (
        this.orderInfo.bonusSwitch && this.orderInfo.detectionBonus > 0 ||
        this.orderInfo.expertDiscount && this.orderInfo.expertDiscount > 0
      );
    }
  },
  watch: {
    orderInfo: {
      handler: function (orderInfo) {
        this.dialogVisible = ![7, 15, 17, 18].includes(Number(orderInfo?.goodsStatus));
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleClick(type) {
      this.$emit('finalPriceClick', type);
    },
    handleClickWenhao() {
      this.dialogVisible = !this.dialogVisible;
    }
  }
};
</script>
<style scoped lang="less">
@media (max-width: 980px) {
  .final-price-box {
    width: 686px;
    margin: 24px auto;
    background-color: #fff;
    border-radius: 12px;
    overflow: hidden;
    .price-wenhao-icon {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      position: relative;
      top: 2px;
    }
  }
  h5 {
    margin: 0 32px;
    // padding: 22px 0;
    // border-bottom: 1px solid #f7f7f7;
    color: #333;
    font-family: 'PingFang SC';
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .congratulation-text {
    color: #ff9602;
    font-family: 'PingFang SC';
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    margin: 24px;
  }

  .congra-box {
    background: #f7f7f7;
    height: 148px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    .price-item {
      color: #ff9602;
    }
  }

  .reclaim-failure-text {
    color: #333;
    font-family: 'PingFang SC';
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    margin: 24px;
  }

  .price-box::after {
    content: '';
    position: absolute;
    bottom: 100%; /* 让三角形出现在容器的上方 */
    left: 60px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 20px solid #F7F7F7; /* 箭头颜色 */
  }
  .price-box {
    position: relative;
    display: flex;
    margin: 32px 24px;
    justify-content: center;
    background-color: #f7f7f7;
    padding: 24px 42px;
    border-radius: 30px;
    .price-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 24px;
      flex-shrink: 0;
      width: 150px;
      .coin-amount {
        display: flex;
        align-items: flex-end;
        height: 68px;
        .coin {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 9px;
        }

        .amount {
          font-size: 48px;
          font-weight: bold;
        }
      }
    }
    .symbol {
      display: flex;
      align-items: center;
      color: #333;
      font-family: 'PingFang SC';
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      // margin-top: 20px;
      margin: 60px 5px 0;
    }
    .price-item-text {
      color: #666;
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      height: 60px;
      margin-bottom: 8px;
      text-align: center;
    }
  }

  .price-total {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 16px 36px;
    flex-shrink: 0;
    width: 150px;
    text-align: center;
    .coin-amount {
      display: flex;
      align-items: flex-end;
      height: 68px;
      .coin {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 12px;
      }

      .amount {
        font-size: 60px;
        font-weight: bold;
      }
    }
  }

  .reclaim-failure-price-box {
    margin: 32px 24px 10px;
    .price-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 8px;
      background: #f7f7f7;
      padding: 28px 24px;
      flex-shrink: 0;
      .coin-amount {
        display: flex;
        align-items: flex-end;
        height: 68px;
        color: #999;
        .coin {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 9px;
        }

        .amount {
          font-size: 48px;
          font-weight: bold;
        }
      }
    }
    .symbol {
      display: flex;
      align-items: center;
      color: #333;
      font-family: 'PingFang SC';
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin: 20px 5px 0;
    }
    .price-item-text {
      color: #666;
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  .btn-box {
    display: flex;
    justify-content: space-around;
    margin-bottom: 24px;
    margin: 0 24px 24px;
    .btn {
      width: 300px;
      height: 80px;
      flex-shrink: 0;
    }

    .btn-sure {
      background: rgba(255, 150, 2, 0.1);
      color: #405FFF;
      font-size: 28px;
      border: none;
      border-radius: 8px;
    }

    .btn-reject {
      border-radius: var(--borderRadius, 8px);
      background: #f7f7f7;
      color: #999;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      border: none;
    }
  }
  .dialog-content {
    padding: 24px 40px 0 48px;
    color: #252629;
    font-family: 'PingFang SC';
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    .row {
      display: flex;
      margin-bottom: 20px;
    }
  }
  .dialog-btn-box {
    display: flex;
    justify-content: space-between;
    margin: 48px;
    .dialog-btn {
      display: flex;
      flex: 1;
      height: 88px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      border-radius: 10px;
      background: var(---Brand-1, #405FFF);
      color: #fff;
      border: none;
      font-size: 28px;
    }
  }
  /deep/.van-dialog__header {
    font-weight: bold;
  }
}

@media (min-width: 981px) {
  .final-price-box {
    width: 1300px;
    margin: 0 auto 15px;
    background-color: #fff;
    border-radius: 12px;
    overflow: hidden;
    text-align: center;
  }
  h5 {
    margin: 0 32px;
    padding-bottom: 32px;
    // border-bottom: 1px solid #f7f7f7;
    color: #333;
    font-family: 'PingFang SC';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .congratulation-text {
    color: #ff9602;
    font-family: 'PingFang SC';
    font-size: 45px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    margin: 0 24px 24px;
  }

  .congratulation-text2 {
    color: #666;
    font-family: 'PingFang SC';
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .congra-box {
    background: #f7f7f7;
    height: 168px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 18px;
    width: 900px;
    .price-item {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ff9602;
    }
  }
  .reclaim-failure-text {
    color: #333;
    font-family: 'PingFang SC';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    margin-bottom: 24px;
  }
  .reclaim-failure-price-box {
    margin: 32px 24px 40px;
    .price-item {
      width: 922px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 8px;
      background: #f7f7f7;
      margin: auto;
      padding: 28px 24px;
      flex-shrink: 0;
      .coin-amount {
        display: flex;
        align-items: flex-end;
        height: 88px;
        color: #999;
        .coin {
          font-size: 30px;
          font-weight: bold;
          margin-bottom: 9px;
        }

        .amount {
          font-size: 60px;
          font-weight: bold;
        }
      }
    }
    .symbol {
      display: flex;
      align-items: center;
      color: #333;
      font-family: 'PingFang SC';
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-top: 20px;
      margin: 20px 5px 0;
    }
    .price-item-text {
      color: #666;
      font-family: 'PingFang SC';
      font-size: 21px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .price-box {
    display: flex;
    margin: 60px auto 45px;
    justify-content: center;
    .price-item {
      display: flex;
      flex-direction: column;
      margin: 0 24px;
      .coin-amount {
        display: flex;
        align-items: flex-end;
        height: 88px;
        .coin {
          font-size: 30px;
          font-weight: bold;
          margin-bottom: 9px;
        }

        .amount {
          font-size: 60px;
          font-weight: bold;
        }
      }
    }
    .symbol {
      display: flex;
      align-items: center;
      color: #333;
      font-family: 'PingFang SC';
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin: 20px 40px 0;
    }
    .price-item-text {
      color: #666;
      font-family: 'PingFang SC';
      font-size: 21px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-align: left;
    }
  }
  .btn-box {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    margin: 0 24px 24px;
    .btn {
      width: 375px;
      height: 72px;
      flex-shrink: 0;
    }

    .btn-sure {
      background: rgba(255, 150, 2, 0.1);
      color: #405FFF;
      font-size: 24px;
      border: none;
      border-radius: 8px;
      margin-right: 65px;
    }

    .btn-reject {
      border-radius: var(--borderRadius, 8px);
      background: #f7f7f7;
      color: #999;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      border: none;
    }
  }
}
</style>
